import React, { useState, useEffect, useCallback } from 'react';
import customerService from '../../services/customerService';
import PurchaseHistory from './PurchaseHistory';
import LoyaltyCardDetails from './LoyaltyCardDetails';

const CustomerViewModal = ({ customer, onCancel }) => {
  // --- 1. NEW, UNIFIED STATE ---
  // We will now store the full, detailed customer object fetched from the new endpoint.
  const [detailedCustomer, setDetailedCustomer] = useState(null);
  const [salesHistory, setSalesHistory] = useState([]);
  const [activeTab, setActiveTab] = useState('history');
  const [isLoading, setIsLoading] = useState(true);

  // --- 2. THE NEW, UNIFIED DATA FETCHING LOGIC ---
  const fetchData = useCallback(async () => {
    if (!customer?._id) return;
    setIsLoading(true);
    try {
      // Make a single API call to our new, powerful endpoint
      const responseData = await customerService.getCustomerDetails(customer._id);
      setDetailedCustomer(responseData.customer);
      setSalesHistory(responseData.salesHistory);
    } catch (error) {
      console.error("Failed to fetch customer details", error);
    } finally {
      setIsLoading(false);
    }
  }, [customer?._id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{customer.fullName} ({customer.customerId})</h2>
          <button onClick={onCancel} className="bg-gray-200 px-4 py-2 rounded-md">Close</button>
        </div>
        
        <div className="flex space-x-4 border-b mb-6">
          <button onClick={() => setActiveTab('history')} className={`px-4 py-2 text-sm font-medium ${activeTab === 'history' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500'}`}>Purchase History</button>
          {/* Use the detailedCustomer object to check for a loyalty card */}
          {detailedCustomer?.loyaltyCard && <button onClick={() => setActiveTab('loyalty')} className={`px-4 py-2 text-sm font-medium ${activeTab === 'loyalty' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500'}`}>Loyalty Card</button>}
        </div>

        <div className="flex-grow overflow-y-auto">
          {isLoading ? (
            <p>Loading details...</p>
          ) : (
            <>
              {activeTab === 'history' && <PurchaseHistory sales={salesHistory} />}
              {activeTab === 'loyalty' && <LoyaltyCardDetails card={detailedCustomer?.loyaltyCard} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerViewModal;